<template lang="pug">
div
	section
		input.input(v-model='search', @keyup='fetch_page', :placeholder='placeholder')
	section.flex
		.flex-grow.results
			span.results {{total_results}} results 
			span(v-if='pages > 1').results (Page {{page+1}} of {{pages}})
		.flex-min(style="padding-top:0.25rem")
			button.button(@click='back', v-show='has_back', style="margin:0.25rem") back
			button.button.is-info(@click='forward', v-show='has_next', style="margin:0.25rem") next
	
</template>

<script>
import CrewService from "@/api/crew";

export default {
  name: "Lister",

  props: ["placeholder", "url", "pin", "company", "crew", "mutation", "fetch"],
  data: function() {
    return {
      search: "",
      limit: 5,
      pages: 0,
      page: 0,
      total_results: 0,
      results: []
    };
  },
  mounted: async function() {
    const results = await CrewService.lister(
      this.pin,
      this.company,
      this.crew,
      this.suffix
    );
    this.total_results = results.data.total;
    this.results = results.data.page;
    this.$store.commit(this.mutation, this.results);
    this.page = 0;
    this.pages = Math.ceil(this.total_results / this.limit);
    this.$store.state.bus.$on(this.fetch, async () => {
      this.fetch_page();
    });
  },
  computed: {
    has_back() {
      return this.page > 0;
    },
    has_next() {
      return this.page + 1 < this.pages;
    },
    suffix() {
      return `${this.url}/${this.page * this.limit}/${this.limit}?q=${
        this.search
      }`;
    }
  },
  methods: {
    forward() {
      this.page++;
      this.fetch_page();
    },
    back() {
      this.page--;
      this.fetch_page();
    },
    async fetch_page() {
      const results = await CrewService.lister(
        this.pin,
        this.company,
        this.crew,
        this.suffix
      );
      this.total_results = results.data.total;
      this.results = results.data.page;
      this.pages = Math.ceil(this.total_results / this.limit);
      // The current page could change... if the total number of pages is <
      this.page = this.page > this.pages ? this.pages : this.page;
      this.$store.commit(this.mutation, this.results);
    }
  },
  watch: {
    search() {
      this.page = 0;
    }
  }
};
</script>

<style scoped lang="less">
.results {
  padding-top: 0.25rem;
  color: darkorange !important;
}
</style>
